var map = {
	"./About": [
		"049b",
		"chunk-2d0a3d43"
	],
	"./About.vue": [
		"049b",
		"chunk-2d0a3d43"
	],
	"./Archive": [
		"3465",
		"chunk-6c62bfe4"
	],
	"./Archive.vue": [
		"3465",
		"chunk-6c62bfe4"
	],
	"./Home": [
		"74eb",
		"chunk-2fbd4e01"
	],
	"./Home.vue": [
		"74eb",
		"chunk-2fbd4e01"
	],
	"./Topic": [
		"d054",
		"chunk-d6a2654c"
	],
	"./Topic.vue": [
		"d054",
		"chunk-d6a2654c"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "2f1a";
module.exports = webpackAsyncContext;